<template>
  <div class="image-message">
    <viewer :images="[content.image.imageUrl]">
      <img :src="content.image.imageUrl" :key="content.image.imageUrl" class="images">
    </viewer>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    content() {
      return JSON.parse(this.message.msgJson)
    }
  }
}
</script>

<style>
@import "./styles/imageMessage.css";
</style>




// WEBPACK FOOTER //
// src/components/beautiful-chat/ImageMessage.vue